// Masa siyahısının seçili bölməyə (table group) uyğunlaşdırılması.
//
// ═══ NİYƏ EKRAN TƏRƏFİNDƏ DƏ SÜZGƏC VAR ═══
//
// Süzgəc serverdə tətbiq olunur (`GET /tables?table_group_id=`), amma
// `Masalar.tsx`-dəki `tables` state-inə BİR NEÇƏ asinxron yol yazır:
//
//   • bölmə dəyişimi (fetchTables)
//   • WS qopanda 10 saniyəlik fallback polling
//   • `table.created` / `table.transferred` hadisələri
//   • WS yenidən qoşulanda "reconciliation" fetch-i
//
// Onlardan biri başqa bölmənin (və ya bütün masaların) siyahısını yazan kimi
// ekran qarışırdı: ofisant "Salon"a basır, terasın masaları da görünürdü.
// Real şikayət məhz bu idi və ən çox OFLAYN rejimdə baş verirdi, çünki
// fallback polling yalnız WS qopanda işləyir.
//
// Serverdəki süzgəc qalır (şəbəkəyə lazımsız məlumat getməsin), bu funksiya
// isə ekranın təminatıdır: hansı yol yazsa da yanlış bölmə görünə bilməz.
//
// Semantika serverlə (gateway `posTablesListToCloud`) EYNİDİR:
//   • qrup 0 ("Hamısı") → süzgəc yoxdur
//   • əks halda → yalnız `table_group_id` uyğun gələnlər
//   • bölməsiz masa (`table_group_id: null`) yalnız "Hamısı"da görünür

export interface GroupScopedTable {
  table_group_id?: number | string | null;
}

/** Seçili bölmə id-si (0 = Hamısı) — mətn gəlsə də rəqəmə çevrilir. */
export function normalizeGroupId(value: unknown): number {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

export function scopeTablesToGroup<T extends GroupScopedTable>(
  tables: T[],
  groupId: unknown,
): T[] {
  const active = normalizeGroupId(groupId);
  if (active === 0) return tables;
  return tables.filter((table) => {
    const raw = table?.table_group_id;
    if (raw === null || raw === undefined || raw === '') return false;
    return Number(raw) === active;
  });
}

// ═══ KÖHNƏLMİŞ CAVABIN ATILMASI ═══
//
// `scopeTablesToGroup` yanlış bölmənin GÖRÜNMƏSİNİ dayandırır, amma köhnəlmiş
// cavabın state-i əvəz etməsini yox. Fərq oflayn/yavaş şəbəkədə hiss olunur:
//
//   ofisant "Salon"a basır   → sorğu #1 gedir
//   dərhal "Teras"a basır    → sorğu #2 gedir
//   #2 tez qayıdır           → teras masaları ekranda
//   #1 gec qayıdır           → SALON masaları state-ə yazılır
//
// Ekranda teras tabı seçili qalır, `scopeTablesToGroup` isə salon masalarını
// süzüb ATIR — nəticədə grid BOŞ görünür. "Masalar bir anlıq görünüb itir"
// şikayətinin bir hissəsi məhz budur.
//
// İki müstəqil şərt yoxlanılır, çünki hər biri ayrı bir hal tutur:
//   • növbə nömrəsi → eyni bölmə üçün paralel sorğular
//   • bölmə id-si   → cavab gələnə qədər istifadəçinin bölməni dəyişməsi
//     (növbə nömrəsi eyni ola bilər: WS fallback tək sorğu atır)

export interface TableResponseFreshness {
  /** Bu sorğunun növbə nömrəsi. */
  seq: number;
  /** Ən son başlanan sorğunun nömrəsi. */
  latestSeq: number;
  /** Sorğunun getdiyi bölmə. */
  requestedGroup: unknown;
  /** Cavab gələn andakı seçili bölmə. */
  currentGroup: unknown;
}

/** true → cavab ekrana AİD DEYİL, state-ə yazılmamalıdır. */
export function isStaleTableResponse(f: TableResponseFreshness): boolean {
  if (f.seq !== f.latestSeq) return true;
  return normalizeGroupId(f.requestedGroup) !== normalizeGroupId(f.currentGroup);
}
